export default "__VITE_ASSET__yBWUPVN8__"